import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from 'app/App';
import history from 'history/browser';

export const acquireToken = async (
    scopes: string[]
) => {
    const account = msalInstance.getActiveAccount();

    return await msalInstance
        .acquireTokenSilent({ scopes: scopes, account: account ?? undefined })
        .catch((error: any): any => handleAcquireTokenFail(error, scopes));
};

export const requiresInteraction = (error: any) => {
    const errorMessage = getErrorMessage(error);
    if (!errorMessage) {
        return false;
    }
    else if (error instanceof InteractionRequiredAuthError) {
        return true;
    }
    else {
        return (
            errorMessage.indexOf('consent_required') > -1 ||
            errorMessage.indexOf('interaction_required') > -1 ||
            errorMessage.indexOf('login_required') > -1
        );
    }
};

export const requiresBrowserOpenPopupUnblock = (error: any) => {
    const errorMessage = getErrorMessage(error);
    
    if (!errorMessage) {
        return false;
    }

    const isBrowserError = error instanceof BrowserAuthError;
    const isPopupError = errorMessage === "popup_window_error";

    return isBrowserError && isPopupError;
}

export const isAlreadyInProgress = (error: any) => {
    const errorMessage = getErrorMessage(error);
    
    if (!errorMessage) {
        return false;
    }

    return errorMessage ===  "interaction_in_progress" || (errorMessage === "unable_to_fallback_to_interaction" && error.errorMessage?.includes("interaction is already in progress"));
}

const getErrorMessage = (error: any) => {
    const errorMessage = error?.errorCode;
    
    if (!error || !errorMessage || !errorMessage.length) {
        return null;
    }

    return errorMessage;
}

const acquireTokenInteractive = async (
    scopes: string[]
) => {
    return await msalInstance
        .acquireTokenRedirect({ scopes: scopes })
        .catch((error: any): any => handleAcquireTokenFail(error, scopes));
};

export const handleAcquireTokenFail = async (
    error: any,
    scopes: string[]
) => {
    if (isAlreadyInProgress(error)){
        console.error('Already in progress:', error.errorCode);
    }
    else if (requiresInteraction(error)) {
        return await acquireTokenInteractive(scopes);
    }
    else if (requiresBrowserOpenPopupUnblock(error)){
        history.push({
            pathname: '/blocked-browser-popup'
        })
        window.location.reload();
    }
    else {
        console.error('Non-interactive error:', error.errorCode);
    }
};